import ChevronRightIcon from '@/components/icons/ChevronRightIcon';
import React from 'react';
import styles from './style.module.css';

export type Style = 'filled' | 'outlined';

export type navcardProps = {
  className?: string;
  style?: Style;
  title?: string;
  description?: string;
  Icon?: React.ReactElement;
  onClick?: () => void;
};

const NavCard: React.FC<navcardProps> = ({
  title,
  description,
  Icon,
  style = 'filled',
  className,
  onClick,
}) => {
  function switchStyle() {
    return style == 'filled'
      ? styles['nav-container-filled']
      : styles['nav-container-outlined'];
  }
  return (
    <div className={switchStyle()} onClick={onClick}>
      <div className={styles['nav-body']}>
        {Icon ? Icon : ''}
        <div className={styles['text-content']}>
          <div className={styles['title']}>{title ? title : ''}</div>
          <div className={styles['desc']}>{description ? description : ''}</div>
        </div>
      </div>
      <ChevronRightIcon className={styles['chevron']}></ChevronRightIcon>
    </div>
  );
};

export default NavCard;
